import { render, staticRenderFns } from "./FollowUpPatientStep5Component.vue?vue&type=template&id=443f5372&scoped=true&"
import script from "./FollowUpPatientStep5Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep5Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep5Component.vue?vue&type=style&index=0&id=443f5372&prod&lang=scss&scoped=true&"
import style1 from "./FollowUpPatientStep5Component.vue?vue&type=style&index=1&id=443f5372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443f5372",
  null
  
)

export default component.exports